<div #element [attr.placeholder]="label"></div>
